import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const processAuth = async () => {
      // Check for session_id in URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (sessionId) {
        // Process session_id
        const result = await login(sessionId);
        
        if (result.success) {
          // Clean URL fragment
          window.history.replaceState(null, '', '/dashboard');
          // Redirect to dashboard
          navigate('/dashboard', { replace: true });
        } else {
          setError(result.error || 'Authentication failed');
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login', { replace: true });
          }, 3000);
        }
      } else if (user) {
        // Already authenticated, redirect to dashboard
        navigate('/dashboard', { replace: true });
      } else {
        // No session_id and not authenticated, redirect to login
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [login, navigate, user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {error ? (
          <div className="space-y-4">
            <div className="text-red-500 text-xl font-semibold">Authentication Error</div>
            <p className="text-gray-600">{error}</p>
            <p className="text-sm text-gray-500">Redirecting to login page...</p>
          </div>
        ) : (
          <div className="space-y-4">
            <Loader2 className="h-12 w-12 animate-spin mx-auto text-orange-500" data-testid="auth-loading-spinner" />
            <div className="text-xl font-semibold">Completing sign in...</div>
            <p className="text-gray-600">Please wait while we set up your account</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;